export enum ScanType {
  Dropoff = 0,
  Package = 1,
  HALPackage = 2,
}

export enum TableActionType {
  Email = 0,
  Edit = 1,
  Delete = 2,
  Return = 3,
  Deliver = 4,
  Comment = 5,
  ShowImage = 6,
  PrintLabel = 7,
  SendInvite = 8,
  ResendLink = 9,
  CancelShipment = 10,
  ExportPDF = 11,
  ViewDetails = 12,
  Convert = 13,
  PickUp = 14,
}

export enum TableDataType {
  Text = 0,
  LongDate = 1,
  ShortDate = 2,
  StringDate = 4,
  Money = 5,
  Mobile = 6,
  Tags = 7,
  OnlyTimeDate = 8
}

export enum FilterType {
  Text = 0,
  MultiSelect = 1,
  DateRange = 2
}

export enum FilterStoragePageKey {
  Location = 'location',
  Package = 'package',
  Dropoff = 'dropoff',
  Lead = 'lead',
  User = 'user',
  Customer = 'customer',
  KnowledgeCenter = 'knowledge-center',
}

export enum PackageStatusTypeEnum
{
    None = 0,
    CreatePackage = 1,
    UpdatePackage = 2,
    HalCreatePackage = 3,
    HalSearchPackage = 4
}

export enum PackageStatusEnum
{
    New = 1,
    Received = 2,
    ReceivedDamaged = 3,
    Scheduled = 4,
    Picked = 5,
    Delivered = 6,
    Returned = 7,
    Refused = 8,
    Disposed = 9,
    Deleted = 10,
    Cancelled = 11,
    ReceivedEmpty = 13,
    ReceivedAtWareHouse = 14,
    Redirect = 15
}

export enum OrderType {
  Retailer = 1,
  PPUAccount = 2,
  HAL = 3  
}

export enum PackageSizeType {
  Regular = 1,
  Large = 2,
  Oversized = 3  
}

export enum SubscriptionType {
  PayPerUse = 0,
  IndividualMonth = 1,
  BusinessMonth = 2
}

export enum SubscriptionStatus {
  Active = 1,
  PastDue = 2,
  Unpaid = 3,             
  Canceled = 4 
}

export enum SubscriptionFinalStatus {
  NotSubscribed = 0,
  Expired = 1,
  Overdue = 2,
  Active = 3,
  PayPerUse = 4  
}

export enum PaymentStatus {
  NotCreated = 0,
  Pending = 1,
  Successful = 2,
  Failed = 3,
  Authorized = 5
}

export enum ReceiptStep {
  Handoff = 0,
  Form = 1,
  ThankYou = 2
}

export enum LocationType {
  PenguinPickup = 1,
  PartnerShop = 2,
  Locker = 3,
  PartnerCorporate = 5
}

// Update to proper statuses
export enum LocationStatusEnum {
  Prospect = 1,
  CourierApproval = 2,
  LegalFinance = 3,
  CourierMapping = 4,
  HardwareSetup = 5,
  WelcomeKit = 6,
  Training = 7,
  Compliance = 8,
  StoreDetailsReview = 9,
  ReadyToGoLive = 10,
  Active = 11,
  Inactive = 12,
  Undefined = 13
}

export enum BarcodeTypeEnum {
  _1D = 1,
  _2D = 2,
  PIN = 3,
  QRCode = 4
}

// Knowledge Center
export enum TrainingCategoryTypeEnum {
  CustomerDropOff = 1,
  DeliverToCustomer = 2,
  CourierDropOff = 3,
  ReturnToCourier = 4,
  Outbounds = 5,
  Printing = 6,
  Reporting = 7,
  Support = 8,
  Other = 9
}

export enum PackageRefusalTypeEnum {
  Damaged = 1,
  Other = 2,  
}

export enum LabelTypeEnum {
  ZPL = 1,
  PDF = 2,  
}

export enum LeadStatusEnum {
  New = 1,
  Contacted = 2,
  Won = 3,
  Lost = 4,
}

export enum CustomerDropoffStatusEnum {
  Received = 1,
  Picked = 2  
}